module.exports = __webpack_public_path__ + "img/logoHorTransp.68678b90.png";